/**
 * @ngdoc service
 * @name tools
 *
 * @description
 * Useful tools functions.
 */
module.factory('tools', ['lodash', 'moment', function (lodash, moment) {
    'use strict';
    return {
        // Get array of numbers from start to end
        // Example : start = 2, end = 7 -> return [2, 3, 4, 5, 6, 7]
        getRange: function (start, end) {
            var range = [];
            for (var i = start; i <= end; ++i) {
                range.push(i);
            }
            return range;
        },
        // Check if array is empty
        isEmptyArray: function (array) {
            return (array && array.length === 0);
        },
        // Check if object is empty
        isEmptyObject: function (object) {
            return (object && Object.keys(object).length === 0);
        },
        print: function () {
            window.print();
        },
        replace: function (text, obj) {
            lodash.keys(obj).forEach(function (k) {
                text = text.replace(new RegExp('{' + k + '}', 'g'), obj[k]);
            });
            return text;
        },
        formatGAddress: function (gAddress) {

            /* format google address to comprehensive object */
            var address = {};
            var route = [];
            if (!gAddress.address_components) {
                return address;
            } else {
                for (var i = 0; i < gAddress.address_components.length; i += 1) {
                    address[gAddress.address_components[i].types[0]] = gAddress.address_components[i].long_name;
                }
                if (address.street_number) {
                    route.push(address.street_number);
                }
                route.push(address.route);
                return {
                    address: route.join(' '),
                    city: address.locality,
                    postal_code: address.postal_code ? address.postal_code : '',
                    country: address.country
                };
            }
        },
        isMinor: function (date) {
            return date ? moment().diff(moment(date, ["DD/MM/YYYY", "YYYY-MM-DD"]), 'years') < 18 : false;
        },
        setMetaValue: function (metaTag, value) {
            if (!value || value.length === 0) {
                console.error('set keywords need tags');
                return;
            }
            var meta = document.querySelector('meta[name="' + metaTag +'"]');
            if (!meta) {
                console.error('cannot find meta keyword in DOM');
                return;
            }

            meta.setAttribute('content', value);
        },
        filterMembership: function(product) {
            return product.family === 'Adhésion/cotisation individuelle';
        },
        parseMark: function (value) {
            var intValue = parseInt(value);
            var floatValue = parseFloat(value);

            return intValue === floatValue ? intValue : floatValue;
        }
    };
}]);
